import { showToast } from '@bp/ui-components';
import { CombinedError } from 'urql';
import { t } from 'i18next';

const autoCloseTime = 2000;

export function showSuccessSaveToast(count?: number, time?: number) {
  showToast(t('toast.success.save', { count: count ?? 1 }), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showSuccessCreateToast(count?: number, time?: number) {
  showToast(t('toast.success.create', { count: count ?? 1 }), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showSuccessDeleteToast(count?: number, time?: number) {
  showToast(t('toast.success.delete', { count: count ?? 1 }), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showSuccessUpdateToast(count?: number, time?: number) {
  showToast(t('toast.success.update', { count: count ?? 1 }), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showSuccessDuplicateToast(count?: number, time?: number) {
  showToast(t('toast.success.duplicate', { count: count ?? 1 }), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showSuccessToast(message?: string, time?: number) {
  showToast(message ?? t('toast.success.common'), {
    autoClose: time ?? autoCloseTime,
    type: 'success',
  });
}

export function showUserDbErrorToast(time?: number) {
  showToast(t('toast.error.database'), {
    autoClose: time ?? autoCloseTime,
    type: 'error',
  });
}

export function showErrorToast(message?: string, time?: number) {
  showToast(message ?? t('toast.error.common'), {
    autoClose: time ?? autoCloseTime,
    type: 'error',
  });
}
